module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin6.89622ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin6.png
// module id = gu1C
// module chunks = 5